export class Login {

    constructor(item: Login | void) {
        if(item instanceof Object) {
            this.email = item.email;
            this.password = item.password;
        }
    }

    email: string = "";
    password: string = "";
}
export class Register {

    constructor(item: User|void) {
        if(item instanceof Object) {
            this.email = item.email;
            this.nome = item.nome;
            this.id = item.id;
        }
    }
    id: number = -1;
    email: string = "";
    nome: string = "";
    userId: string = "";
}
export class User { 

    constructor(item: User|void) {
        if(item instanceof Object) {
            this.email = item.email;
            this.nome = item.nome;
            this.id = item.id;
        }
    }
    id: number = -1;
    email: string = "";
    nome: string = "";
}